import { render, staticRenderFns } from "./Rv2024View.vue?vue&type=template&id=2f99f3ec&scoped=true&"
import script from "./Rv2024View.vue?vue&type=script&lang=js&"
export * from "./Rv2024View.vue?vue&type=script&lang=js&"
import style0 from "./Rv2024View.vue?vue&type=style&index=0&id=2f99f3ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f99f3ec",
  null
  
)

export default component.exports